module.exports = __webpack_public_path__ + "static/media/logo-white.23e46dbc.png";